import { useAuth0, User } from "@auth0/auth0-react"
import { useEffect } from "react"
import { initApi } from "../../../lib/api"
import { login, setCurrentClient } from "../../../store/actions"

import { CurrentClient } from "../../../lib/currentClient"
import { useStoreShared } from "../../../store"

export function useAutoLogin() {
  const { loginWithRedirect, getAccessTokenSilently, user } = useAuth0()
  const { stateShared, dispatchShared } = useStoreShared()
  const CUSTOM_CLAIMS_NAMESPACE = "https://storever.com/"
  const CUSTOM_CLAIMS_DEFAULT_CLIENT_UUID = CUSTOM_CLAIMS_NAMESPACE + "default_client_uuid"
  const CUSTOM_CLAIMS_DEFAULT_CLIENT_NAME = CUSTOM_CLAIMS_NAMESPACE + "default_client_name"

  useEffect(() => {
    (async () => {
      try {
        const token = await getAccessTokenSilently()

        if (sessionStorage.getItem("auth0Token") === null) {
          sessionStorage.setItem("auth0Token", token)
        }

        dispatchShared(login(user as User))

        if (user) {
          const currentClient = {
            name: user[CUSTOM_CLAIMS_DEFAULT_CLIENT_NAME],
            uuid: user[CUSTOM_CLAIMS_DEFAULT_CLIENT_UUID],
          }

          if (sessionStorage.getItem("currentClientName") === null) {
            sessionStorage.setItem("currentClientName", currentClient.name)
            sessionStorage.setItem("currentClientUuid", currentClient.uuid)
            dispatchShared(setCurrentClient(currentClient as CurrentClient))
          } else {
            const currentClientStore = {
              name: sessionStorage.getItem("currentClientName"),
              uuid: sessionStorage.getItem("currentClientUuid"),
            }
            dispatchShared(setCurrentClient(currentClientStore as CurrentClient))
          }
        }
        if (stateShared.currentClient?.name) {
          initApi(token)
        }
      } catch (error) {
        sessionStorage.clear()
        await loginWithRedirect()
      }
    })()
  }, [getAccessTokenSilently, loginWithRedirect, user, stateShared.currentClient?.name])
}
